import { createTranslationsContext } from '@ori/presentation-translations';
var _createTranslationsCo = createTranslationsContext({
    defaultTranslations: {
      buy: 'Buy',
      choose: 'Choose',
      lowestPrice: 'Our lowest price, the last 30 days before current price, was',
      mrpStatement: 'Inclusive of all taxes',
      newEdition: 'New edition',
      newEditionAvailable: 'New edition available',
      replace: 'Replace',
      replaceWith: 'Replace with',
      reserve: 'Reserve',
      save: 'Save'
    }
  }),
  defaultTranslations = _createTranslationsCo.defaultTranslations,
  translationsContext = _createTranslationsCo.translationsContext,
  TranslationsProvider = _createTranslationsCo.TranslationsProvider,
  useTranslations = _createTranslationsCo.useTranslations;
export { defaultTranslations, translationsContext, TranslationsProvider, useTranslations };